module.exports = __webpack_public_path__ + "img/favicons/ape/favicon.ico";